<template>
  <div>
    <PageHeader :title="t('title')" />
    <Loading v-if="loading" />
    <div v-else-if="offers.length === 0" class="text-center mt-4 py-2">
      <p>{{ t("no_results") }}</p>
    </div>
    <div v-else>
      <Table :columns="columns" :data="offers" />
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        :totalCount="totalCount"
        @changePage="handleChangePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { useI18n } from "vue-i18n";
import { PageHeader, Loading, Table, Pagination } from "@estaly/ui";

export default {
  components: { PageHeader, Loading, Table, Pagination },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      loading: true,
      columns: [],
    };
  },

  computed: {
    ...mapState("contractDistributions", {
      offers: "index",
      currentPage: "currentPage",
      totalPages: "totalPages",
      totalCount: "totalCount",
    }),
  },

  async created() {
    this.buildColumns();
    await this.retrieveOffers();
  },

  methods: {
    ...mapActions("contractDistributions", { fetchOffers: "fetchIndex" }),

    buildColumns() {
      this.columns = [
        { label: this.t("column_category"), field: "translatedCategory" },
        { label: this.t("column_insurer_reference"), field: "insurerContractGroupReference" },
        { label: this.t("column_max_insurable_price"), field: "maxInsurablePrice", price: true },
      ];
    },

    async retrieveOffers(page = 1) {
      this.loading = true;
      await this.fetchOffers({ page });
      this.loading = false;
    },

    handleChangePage(page) {
      this.retrieveOffers(page);
    },
  },
};
</script>

<i18n src="./OfferList.i18n.json"></i18n>
